import React, { useContext, useEffect, useRef, useState } from 'react'
import CustomImage from '../../components/customImage/customImage'
import StarIcon from '../../assets/rating-star-icon.svg'
import CartIcon from '../../assets/cart-svgrepo-com@3x.png'
import thunderIcon from '../../assets/thunder-svgrepo-com@3x.png'
import favoriteIcon from '../../assets/add-wishlist-icon.svg'
import AddedToWishlist from '../../assets/added-wishlist-icon.svg'
import shareIcon from '../../assets/share-svgrepo-com-4@3x.png'
import locationIcon from '../../assets/location-pin-svgrepo-com-2@3x.png'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import useTemplateHook from '../../components/template/templateHook'
import cartTick from '../../assets/cart-tick.png'
import { useNavigate, useParams } from 'react-router'
import { ECOMMERCE_API, PRODUCT_FILTER_API } from '../../utils/apiUrls'
import useAxios from 'axios-hooks'
import { AppContext } from '../../context/app'
import SliderWrapper from '../../components/template/eCommerce/_SlickSlider'
import ReviewsListing from '../../components/reviewRating'
import RelatedProduct from './relatedProducts'
import ShareModal from '../../components/shareModal/shareModal'
import { create_share_url, snakeToTitle } from '../../utils/helper'
import getSymbolFromCurrency from 'currency-symbol-map'
import { isEmpty } from 'lodash'
import { ContentContext } from '../../context/content'
import PlayIcon from '../../assets/play-circle-thick.svg'
import arrowIcon from '../../assets/arrow-next-small-svgrepo-com@3x.png'
import ECommerceTrailerPlayer from '../../components/ecommPlayer/ecommerceTrailerPlayer'
import DescriptionModal from './descriptionModal'

const ProductDetail = () => {
  const navigate = useNavigate()
  const product_id = useParams().product_id
  const firstVariationRef = useRef(null)
  const secondVariationRef = useRef(null)
  const sliderRef = useRef(null)

  const { LeftArrow, RightArrow, getTemplateImage } = useTemplateHook()
  const [shareModal, setShareModal] = useState(false)
  const [selectedImage, setSelectedImage] = useState(0)
  const [quantity, setQuantity] = useState(1)
  const [productSKU, setProductSKU] = useState(0)
  const [selectedTab, setSelectedTab] = useState('related_product')
  const { setLoader, updateUserCart, isLogin, setOpenLoginModal, userCart, userObj } =
    useContext(AppContext)
  const { addRemoveWishList, isInWishList } = useContext(ContentContext)
  const [selectedAddress, setSelectedAddress] = useState({})

  const [addedToCart, setAddedToCart] = useState(false)
  const [product, setProduct] = useState({})
  const [productAssets, setProductAssets] = useState([])
  const [firstVariationValues, setFirstVariationValues] = useState([])
  const [secondVariationValues, setSecondVariationValues] = useState([])
  const [selectedVariation, setSelectedVariation] = useState({})
  const [openDescriptionModal, setOpenDescriptionModal] = useState(false)

  // Animation states
  const [show, setShow] = useState(false)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [imageOpacity, setImageOpacity] = useState(1)
  const [transform, setTransform] = useState(1)

  const cartCount = userCart?.products?.length || 0

  const [{ data: productData, loading: productLoading }, productCall] = useAxios(
    {
      url: `${ECOMMERCE_API}/product/${product_id}`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: relatedProducts, loading: relatedProductsLoading }, relatedProductsCall] =
    useAxios(
      {
        url: `${PRODUCT_FILTER_API}`,
        method: 'post',
      },
      { manual: true },
    )

  // Show content on mount
  useEffect(() => {
    setTimeout(() => setShow(true), 10)
  }, [])

  useEffect(() => {
    setImageOpacity(0.6)
    setTransform(1.2)
    const timer = setTimeout(() => {
      setTransform(1)
      setImageOpacity(1)
    }, 700)
    return () => clearTimeout(timer)
  }, [selectedImage])

  useEffect(() => {
    productCall()
  }, [product_id])

  useEffect(() => {
    setLoader(productLoading || relatedProductsLoading)
  }, [productLoading, relatedProductsLoading])

  useEffect(() => {
    if (productData && productData.success) {
      const temp = productData.data
      setProduct(temp)
      let tempImg = []
      for (let i = 0; i < temp?.img_s3_keys?.length; i++) {
        const ele = temp.img_s3_keys[i]
        if (ele) {
          tempImg.push({
            assetType: 'image',
            thumbnailS3Key: ele,
            asset: ele,
          })
        }
      }

      if (temp?.is_variation_product && !isEmpty(temp.variations)) {
        let tempFirstVariation = []
        let tempSecondVariation = []
        for (let i = 0; i < temp.variations.length; i++) {
          const element = temp.variations[i]
          if (!isEmpty(element.first_variation)) {
            tempFirstVariation.push(element.first_variation)
          }

          if (!isEmpty(element.second_variation)) {
            tempSecondVariation.push(element.second_variation)
          }
          if (element.is_default) {
            setSelectedVariation(element)
            setProductSKU(element?.sku)
          }
          if (element.in_stock && element?.img_s3_keys[0].length > 0) {
            tempImg.push({
              assetType: 'image',
              thumbnailS3Key: element?.img_s3_keys[0],
              asset: element?.img_s3_keys[0],
              variation_id: element._id,
            })
            if (element.is_default) {
              setSelectedImage(tempImg.length - 1)
              goToSlide(tempImg.length - 1)
            }
          }
        }
        tempFirstVariation = [
          ...new Map(tempFirstVariation.map((item) => [item.value, item])).values(),
        ]
        tempSecondVariation = [
          ...new Map(tempSecondVariation.map((item) => [item.value, item])).values(),
        ]
        setFirstVariationValues([...tempFirstVariation])
        setSecondVariationValues([...tempSecondVariation])
      }

      if (!temp?.is_variation_product && temp?.in_stock) {
        setProductSKU(temp?.quantity)
      }

      relatedProductsCall({
        data: {
          categories: temp?.category?.map((item) => item.id) || [],
        },
      })

      for (let i = 0; i < temp?.trailer_s3_keys?.length; i++) {
        const ele = temp.trailer_s3_keys[i]
        if (ele) {
          tempImg.push({
            assetType: 'video',
            thumbnailS3Key: temp.img_s3_keys.find((info) => info !== ''),
            asset: ele,
          })
        }
      }
      setProductAssets([...tempImg])
    }
  }, [productData])

  useEffect(() => {
    if (userObj && !isEmpty(userObj?.eccom_address)) {
      let tempDefaultObj = userObj?.eccom_address.find((item) => item.default)

      if (tempDefaultObj) {
        setSelectedAddress({ ...tempDefaultObj })
      } else {
        setSelectedAddress({ ...userObj?.eccom_address[0] })
      }
    }
  }, [userObj])

  // Handle tab switching with transition
  const handleTabChange = (tab) => {
    if (tab === selectedTab) return

    setIsTransitioning(true)
    setShow(false)

    setTimeout(() => {
      setSelectedTab(tab)
      setShow(true)
      setIsTransitioning(false)
    }, 300)
  }

  const handleAddToCart = () => {
    if (!isLogin) {
      setOpenLoginModal(true)
      return
    }

    updateUserCart(
      product_id,
      quantity,
      product?.is_variation_product ? selectedVariation?._id : '',
    )
    setAddedToCart(true)
  }

  const handleInstantCheckout = () => {
    if (!isLogin) {
      setOpenLoginModal(true)
      return
    }

    updateUserCart(
      product_id,
      quantity,
      product?.is_variation_product ? selectedVariation?._id : '',
    )
    setAddedToCart(true)
    navigate('/cart-details')
  }

  const handleCustomMetadata = (id, value, name, type) => {
    if (type === 'link') {
      const url = value.link.includes('http') ? value.link : `http://${value.link}`
      window.open(url, '_blank')
      return
    }
  }

  const getProductPrice = () => {
    if (!product.is_variation_product && isEmpty(selectedVariation)) return product?.price

    return selectedVariation.price
  }

  const checkVariationIsSelected = (info, key) => {
    if (isEmpty(selectedVariation) || isEmpty(selectedVariation[key])) return

    return selectedVariation[key].value === info.value
  }

  const checkVariationIsDisabled = (info, key) => {
    if (isEmpty(selectedVariation)) return false

    const oppKey = key === 'first_variation' ? 'second_variation' : 'first_variation'

    for (let i = 0; i < product?.variations.length; i++) {
      const ele = product?.variations[i]

      if (
        ele[key]?.value === info.value &&
        ele[oppKey]?.value === selectedVariation[oppKey]?.value &&
        ele.in_stock
      ) {
        return false
      }
    }

    return true
  }

  const handleVariationChange = (info, key) => {
    if (isEmpty(selectedVariation)) return

    const oppKey = key === 'first_variation' ? 'second_variation' : 'first_variation'

    for (let i = 0; i < product.variations.length; i++) {
      const ele = product.variations[i]

      if (
        ele[key].value === info.value &&
        ele[oppKey]?.value === selectedVariation[oppKey]?.value
      ) {
        if (ele?.img_s3_keys[0].length > 0) {
          let index = productAssets.findIndex((info) => info?.variation_id === ele._id)
          setSelectedImage(index)
          goToSlide(index)
        }
        setSelectedVariation(ele)
        setProductSKU(ele?.sku)
      }
    }
  }

  const horizontalScroll = (ref, scrollOffset) => {
    if (!ref.current) return

    ref.current.scrollLeft += scrollOffset
  }

  // const productImages = Array.from({ length: 10 }, (_, i) => {
  //   const key = `thumbnail${i + 1}`
  //   return product?.img_s3_keys?.[key] ? getTemplateImage(product.img_s3_keys[key]) : null
  // }).filter(Boolean)

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'black',
          width: window.innerWidth <= 768 ? '24px' : '39px',
          height: window.innerWidth <= 768 ? '24px' : '39px',
          position: 'absolute',
          top: '50%',
          right: window.innerWidth <= 768 ? '-21px' : '-35px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${RightArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={RightArrow}
          alt="Next"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'black',
          width: window.innerWidth <= 768 ? '24px' : '39px',
          height: window.innerWidth <= 768 ? '24px' : '39px',
          position: 'absolute',
          top: '50%',
          left: window.innerWidth <= 768 ? '-21px' : '-35px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${LeftArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={LeftArrow}
          alt="Previous"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  const settings = {
    dots: false,
    autoplaySpeed: 2500,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: true,
    slide: selectedImage + 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  }

  const goToSlide = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index)
    }
  }

  return (
    <div className="flex justify-center items-center  mt-2 xl:mt-4">
      <div className="w-[86.410%] xl:w-[1274px]">
        {productLoading ? (
          <></>
        ) : (
          <div className="mx-auto">
            {/* Top Icons Bar for Mobile/Tablet */}
            <div className="flex items-center justify-end mb-4 xl:hidden">
              <div
                className="flex justify-center items-center rounded-md"
                style={{ width: '36px', height: '36px', backgroundColor: '#2a3644' }}
                onClick={() => setShareModal(true)}
              >
                <img src={shareIcon} alt="share" style={{ height: '14px', width: 'auto' }} />
              </div>

              <div
                className="flex justify-center items-center rounded-md mx-2.5"
                style={{ width: '36px', height: '36px', backgroundColor: '#2a3644' }}
                onClick={() => addRemoveWishList(product_id)}
              >
                <img
                  src={isInWishList(product_id) ? AddedToWishlist : favoriteIcon}
                  alt="added to wishlist"
                  style={{ height: '25px', width: 'auto' }}
                />
              </div>

              <button
                className="flex items-center justify-center rounded-md"
                style={{ border: 'solid 1.2px #f60', height: '36px', width: '102px' }}
              >
                <img
                  src={CartIcon}
                  alt="cart"
                  style={{ width: '21px' }}
                  className="aspect-square"
                />
                <p className="ml-1 mr-2 text-xs text-white">Cart</p>
                <div
                  className="flex justify-center items-center"
                  style={{
                    width: '22px',
                    height: '22px',
                    borderRadius: '50%',
                    backgroundColor: cartCount > 0 ? '#f60' : '#2a3644',
                  }}
                >
                  <span className="text-xs " style={{ color: cartCount > 0 ? 'white' : '#848484' }}>
                    {cartCount}
                  </span>
                </div>
              </button>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 md:gap-14 mb-2 lg:mb-5 border"> */}
            <div className="flex flex-col xl:flex-row justify-between">
              {/* Left - Product Images */}
              <div style={{}} className=" w-full xl:w-[33.75%] xl:ml-[2%]">
                {/* Main Image */}
                <div className="flex justify-center items-center w-full aspect-square overflow-hidden rounded-[10px]">
                  {!isEmpty(productAssets[selectedImage]) ? (
                    productAssets[selectedImage]?.assetType === 'image' ? (
                      <div
                        className="w-full h-full"
                        style={{
                          opacity: imageOpacity,
                          transition: 'transform 0.7s ease-in-out',
                          willChange: 'opacity',
                          transform: `scale(${transform})`,
                        }}
                      >
                        <CustomImage
                          key={`image-${selectedImage}`}
                          imageUrl={getTemplateImage(productAssets[selectedImage]?.thumbnailS3Key)}
                          imgAlt={`Product ${selectedImage + 1}`}
                          imgClass="w-full aspect-square object-contain rounded-[10px]"
                          loaderClass="w-full aspect-square"
                        />
                      </div>
                    ) : (
                      <div
                        className="w-full h-full"
                        style={{
                          opacity: imageOpacity,
                          transition: 'transform 0.7s ease-in-out',
                          willChange: 'opacity',
                          transform: `scale(${transform})`,
                        }}
                      >
                        <ECommerceTrailerPlayer
                          key={`video-${selectedImage}`}
                          quality={480}
                          poster={getTemplateImage(productAssets[selectedImage]?.thumbnailS3Key)}
                          preview={productAssets[selectedImage]?.asset}
                        />
                      </div>
                    )
                  ) : null}
                </div>

                {/* Thumbnail Images */}
                <div className="mt-4 lg:mt-5 w-full">
                  <SliderWrapper>
                    <Slider {...settings} ref={sliderRef}>
                      {productAssets.map((info, index) => (
                        <div key={index} className="">
                          <div
                            onClick={() => setSelectedImage(index)}
                            className="rounded-lg flex justify-center items-center relative"
                          >
                            {info.assetType === 'video' ? (
                              <img
                                style={{ width: '35px', height: '35px' }}
                                className="absolute z-10 cursor-pointer"
                                src={PlayIcon}
                                alt="PlayIcon"
                              />
                            ) : null}
                            <CustomImage
                              imageUrl={getTemplateImage(info?.thumbnailS3Key)}
                              imgAlt={`View ${index + 1}`}
                              imgStyle={{
                                border: selectedImage === index ? '2px solid #FF6602' : '',
                              }}
                              imgClass="w-[96px] xl:w-[124px] rounded-lg cursor-pointer "
                              loaderClass="w-full rounded-lg cursor-pointer "
                            />
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </SliderWrapper>
                </div>
              </div>

              {/* Middle - Product Details */}
              <div style={{}} className="xl:w-[38%]">
                <div className="flex justify-between items-center mb-4">
                  <p
                    style={{}}
                    className="text-white text-sm md:text-base xl:text-xl font-semibold  w-3/4 xl:w-full"
                  >
                    {product?.title}
                  </p>
                </div>
                {!isEmpty(product?.category) ? (
                  <div className="flex text-xs mb-2 xl:mb-2.5 items-center">
                    <p style={{ color: '#979797' }}>Visit</p>
                    <p
                      className="ml-1 cursor-pointer"
                      style={{ color: '#1a7bfb' }}
                      onClick={() =>
                        navigate(
                          `/ecommerce-metadata/${product?.category[0]?.name}/${product?.category[0]?.id}`,
                        )
                      }
                    >
                      {product?.category[0]?.name || ''}
                    </p>
                    <p className="ml-1" style={{ color: '#979797' }}>
                      section
                    </p>
                  </div>
                ) : null}

                {product?.average_rating ? (
                  <div className="flex text-xs mb-2 lg:mb-5 items-center">
                    <p style={{ color: '#979797' }}>Customer Ratings:</p>
                    <div className="flex items-center ml-1">
                      <p className="" style={{ color: '#dedede' }}>
                        {parseFloat(product?.average_rating).toFixed(1)}
                      </p>
                      <img src={StarIcon} alt="star" className="w-2 lg:w-2.5 mx-2" />
                      <p className="" style={{ color: '#979797' }}>
                        ( {product.review_count} ratings )
                      </p>
                    </div>
                  </div>
                ) : null}

                <hr className="mb-3 hidden xl:block" style={{ border: '0.5px solid #707070' }} />

                {/* Price Section */}
                {product?.in_stock && productSKU > 0 ? (
                  <div className="flex items-center gap- mb-3 xl:mb-5">
                    <span className="text-xs" style={{ color: '#979797' }}>
                      Price :
                    </span>
                    <span className="text-white text-base  xl:text-2xl font-semibold flex items-center ml-2">
                      {product?.discount?.enabled
                        ? parseFloat(
                            getProductPrice() -
                              (getProductPrice() * parseInt(product?.discount.discount_value)) /
                                100,
                          ).toFixed(2)
                        : parseFloat(getProductPrice()).toFixed(2)}
                      <span className="text-white text-xs xl:text-base  ml-1">
                        {getSymbolFromCurrency(product?.currency || 'USD')}
                      </span>
                    </span>
                    {product?.discount?.enabled && (
                      <div>
                        <span
                          className="line-through text-xs xl:text-base ml-4"
                          style={{ color: '#808080' }}
                        >
                          {parseFloat(getProductPrice()).toFixed(2)}
                          {getSymbolFromCurrency(product?.currency || 'USD')}
                        </span>
                        <span className="bg-[#ff6600] text-white px-2.5 py-1 rounded-md  text-sm xl:text-base font-semibold ml-2.5">
                          {product?.discount.discount_value}{' '}
                          {product?.discount.value_type === 'percentage' ? '%' : ''} OFF
                        </span>
                      </div>
                    )}
                  </div>
                ) : null}

                <p
                  className="md:mb-3 text-sm md:text-base xl:text-xl font-semibold"
                  style={{ color: product?.in_stock && productSKU > 0 ? '#52c90d' : 'red' }}
                >
                  {product?.in_stock && productSKU > 0 ? 'In Stock' : 'Out of Stock'}
                  {productSKU ? (
                    <span
                      style={{ color: '#979797' }}
                      className="text-xs md:text-sm font-normal ml-[10px]"
                    >
                      {productSKU} units
                    </span>
                  ) : null}
                </p>

                <p className="mb-4 lg:mb-5 text-[10px] lg:text-xs" style={{ color: '#979797' }}>
                  {product?.additional_info}
                </p>
                {/* variants */}
                {product?.is_variation_product && !isEmpty(product?.variations) ? (
                  <div className="mb-4 lg:mb-5">
                    <div className="flex items-center relative">
                      {!isEmpty(firstVariationValues) ? (
                        <div
                          style={{ color: '#979797' }}
                          className={`flex items-center min-w-[52px] lg:min-w-[70px] h-[30px] text-[10px] lg:text-xs`}
                        >
                          {firstVariationValues[0].name}:
                        </div>
                      ) : null}
                      {firstVariationRef?.current &&
                      firstVariationRef?.current?.offsetWidth > 410 ? (
                        <div
                          className="cursor-pointer w-2 absolute rotate-180"
                          onClick={() => horizontalScroll(firstVariationRef, -100)}
                          style={{ left: '54px' }}
                        >
                          <img src={arrowIcon} alt="arrowIcon" className="w-full" />
                        </div>
                      ) : null}
                      <div
                        style={{ overflowX: 'auto', overflowY: 'hidden', scrollBehavior: 'smooth' }}
                        ref={firstVariationRef}
                        className=" flex items-center max- xl:max-w-[486.3px]  hidden-scrollbar-horizontal"
                      >
                        {!isEmpty(firstVariationValues) &&
                          firstVariationValues.map((info, index) => {
                            const isDisabled = checkVariationIsDisabled(info, 'first_variation')
                            return (
                              <div
                                key={index}
                                style={{
                                  background: checkVariationIsSelected(info, 'first_variation')
                                    ? '#ff6600'
                                    : '#2a3644',
                                  opacity: isDisabled ? 0.5 : 1,
                                  whiteSpace: 'nowrap',
                                }}
                                className={`${index && 'ml-2 lg:ml-[13px]'} ${
                                  !isDisabled && 'cursor-pointer'
                                } flex justify-center items-center min-w-[52px] lg:min-w-[70px] h-[30px] text-white text-[10px] lg:text-xs px-1`}
                                onClick={() => {
                                  if (isDisabled) return
                                  handleVariationChange(info, 'first_variation')
                                }}
                              >
                                {info.value}
                              </div>
                            )
                          })}
                      </div>
                      {firstVariationRef?.current &&
                      firstVariationRef?.current?.offsetWidth > 410 ? (
                        <div
                          className="cursor-pointer w-2 absolute -right-3"
                          onClick={() => horizontalScroll(firstVariationRef, 100)}
                        >
                          <img src={arrowIcon} alt="arrowIcon" className="w-full" />
                        </div>
                      ) : null}
                    </div>
                    <div
                      className={`${
                        !isEmpty(secondVariationValues) && 'mt-[17px]'
                      } flex items-center relative`}
                    >
                      {!isEmpty(secondVariationValues) ? (
                        <div
                          style={{ color: '#979797' }}
                          className={`flex items-center min-w-[52px] lg:min-w-[70px] h-[30px] text-[10px] lg:text-xs`}
                        >
                          {secondVariationValues[0].name}:
                        </div>
                      ) : null}
                      {secondVariationRef?.current &&
                      secondVariationRef?.current?.offsetWidth > 410 ? (
                        <div
                          className="cursor-pointer w-2 absolute rotate-180"
                          onClick={() => horizontalScroll(secondVariationRef, -100)}
                          style={{ left: '54px' }}
                        >
                          <img src={arrowIcon} alt="arrowIcon" className="w-full" />
                        </div>
                      ) : null}
                      <div
                        style={{ overflowX: 'auto', overflowY: 'hidden', scrollBehavior: 'smooth' }}
                        ref={secondVariationRef}
                        className=" flex items-center max- xl:max-w-[486.3px]  hidden-scrollbar-horizontal"
                      >
                        {!isEmpty(secondVariationValues) &&
                          secondVariationValues.map((info, index) => {
                            const isDisabled = checkVariationIsDisabled(info, 'second_variation')
                            return (
                              <div
                                key={index}
                                style={{
                                  background: checkVariationIsSelected(info, 'second_variation')
                                    ? '#ff6600'
                                    : '#2a3644',
                                  opacity: isDisabled ? 0.5 : 1,
                                  whiteSpace: 'nowrap',
                                }}
                                className={`${index && 'ml-2 lg:ml-[13px]'} ${
                                  !isDisabled && 'cursor-pointer'
                                } flex justify-center items-center min-w-[52px] lg:min-w-[70px] h-[30px] text-white text-[10px] lg:text-xs px-1 `}
                                onClick={() => {
                                  if (isDisabled) return
                                  handleVariationChange(info, 'second_variation')
                                }}
                              >
                                {info.value}
                              </div>
                            )
                          })}
                      </div>
                      {secondVariationRef?.current &&
                      secondVariationRef?.current?.offsetWidth > 410 ? (
                        <div
                          className="cursor-pointer w-2 absolute -right-3"
                          onClick={() => horizontalScroll(secondVariationRef, 100)}
                        >
                          <img src={arrowIcon} alt="arrowIcon" className="w-full" />
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}

                {/* Quantity & Add to Cart */}
                {product?.in_stock && productSKU > 0 ? (
                  <>
                    <div className="mb-4 lg:mb-[22px]">
                      <div className="flex items-center">
                        <span className="text-xs" style={{ color: '#979797' }}>
                          Quantity :
                        </span>
                        <div className=" h-[36px] lg:h-[43px] flex items-center rounded ml-2.5 text-white">
                          <div
                            className="flex items-center justify-center w-[36px] lg:w-[43px] h-full cursor-pointer xl:text-2xl rounded-s-full overflow-hidden"
                            style={{
                              backgroundColor: '#2a3644',
                            }}
                            onClick={() => setQuantity(Math.max(1, quantity - 1))}
                          >
                            <button className="w-full h-full">-</button>
                          </div>

                          <div
                            className="flex items-center justify-center mx-1 h-full"
                            style={{
                              backgroundColor: '#2a3644',
                              width: '75px',
                            }}
                          >
                            {quantity}
                          </div>

                          <div
                            className={`flex items-center justify-center w-[36px] lg:w-[43px] h-full xl:text-xl rounded-e-full overflow-hidden`}
                            style={{
                              backgroundColor: '#2a3644',
                            }}
                            onClick={
                              quantity === productSKU ? null : () => setQuantity(quantity + 1)
                            }
                          >
                            <button
                              className={`${
                                quantity === productSKU ? 'opacity-50' : 'cursor-pointer'
                              } w-full h-full`}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex mb-2">
                      <button
                        onClick={handleAddToCart}
                        className="text-white rounded-md flex items-center justify-center"
                        style={{ backgroundColor: '#ff6600', width: '168px', height: '42px' }}
                      >
                        <img
                          src={addedToCart ? cartTick : CartIcon}
                          alt="cart"
                          className="w-6 h-6"
                        />
                        <span style={{ marginLeft: '14px' }}>Add to cart</span>
                      </button>

                      <button
                        className=" text-white rounded-md flex items-center justify-center lg:ml-10 ml-5"
                        style={{ border: 'solid 1.2px #f60', width: '168px', height: '42px' }}
                        onClick={handleInstantCheckout}
                      >
                        <img
                          src={thunderIcon}
                          alt="thunder"
                          style={{ width: '11px', height: '14px' }}
                          className=""
                        />
                        <span className="ml-2.5">Instant Checkout</span>
                      </button>
                    </div>
                  </>
                ) : null}

                {/* Description */}
                {product?.description ? (
                  <div className="text-white mb-2 xl:mb-4">
                    <p className="font-semibold lg:text-xl mb-4">Description</p>

                    <p className="text-[10px] lg:text-xs line-clamp-5">{product?.description}</p>
                    {`${product?.description}`.length > 410 ? (
                      <span
                        style={{ color: '#0A82FF' }}
                        className="cursor-pointer italic text-[10px] lg:text-xs border-none"
                        onClick={() => setOpenDescriptionModal(true)}
                      >
                        see more
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                ) : null}

                {/* Product Information */}
                {!isEmpty(product.custom_metadata) ? (
                  <div className="text-white">
                    <p className="font-semibold text-base lg:text-xl mb-4">Product information</p>

                    <div className="text-[10px] lg:text-xs grid grid-cols-[auto_1fr] gap-x-[25px] gap-y-2">
                      {product.custom_metadata.map((info, index) => {
                        return (
                          <>
                            <span style={{ color: '#979797' }}> {info.name} :</span>
                            <div>
                              {info.type === 'checkboxes' ? (
                                info.value.map((obj, idx) => (
                                  <span key={idx}>
                                    {idx !== 0 && <span className={''}>{' , '}</span>}
                                    {obj.name}
                                  </span>
                                ))
                              ) : info.type === 'link' ? (
                                <span
                                  key={index}
                                  onClick={() =>
                                    handleCustomMetadata(info.id, info.value, info.name, info.type)
                                  }
                                  className={'cursor-pointer hover:underline'}
                                >
                                  {info?.value?.placeholder}
                                </span>
                              ) : (
                                <span>{info.value}</span>
                              )}
                            </div>
                          </>
                        )
                      })}

                      {/* <span style={{ color: '#979797' }}>Body Material:</span>
                    <span>{product?.body_material}</span>

                    <span style={{ color: '#979797' }}>Item Dimensions:</span>
                    <span>{product?.dimensions}</span>
                    <span style={{ color: '#979797' }}>Color and finishing:</span>
                    <span>{product?.color_and_finishing}</span>
                    <span style={{ color: '#979797' }}>String Material:</span>
                    <span>{product?.string_material}</span> */}
                    </div>
                  </div>
                ) : null}
              </div>

              {/* Right - Delivery Info */}
              <div style={{ width: '18.5%' }} className="hidden xl:block">
                <div className="flex items-center justify-between">
                  <div
                    className="flex justify-center items-center rounded-md cursor-pointer "
                    style={{ width: '42px', height: '42px', backgroundColor: '#2a3644' }}
                    onClick={() => setShareModal(true)}
                  >
                    <img src={shareIcon} alt="share" style={{ height: '18px', width: 'auto' }} />
                  </div>

                  <div
                    className="flex justify-center items-center rounded-md cursor-pointer"
                    style={{ width: '42px', height: '42px', backgroundColor: '#2a3644' }}
                    onClick={() => addRemoveWishList(product_id)}
                  >
                    <img
                      src={isInWishList(product_id) ? AddedToWishlist : favoriteIcon}
                      alt="added to wishlist"
                      style={{ height: '30px', width: 'auto' }}
                    />
                  </div>
                  <button
                    className=" text-white px-4 rounded-md flex items-center justify-between"
                    style={{ border: 'solid 1.2px #f60', height: '42px', width: '128px' }}
                    onClick={isLogin ? () => navigate('/cart-details') : null}
                  >
                    <img src={CartIcon} alt="cart" className="w-5 object-contain" />
                    <span className="">Cart</span>
                    <div
                      className="flex justify-center items-center"
                      style={{
                        width: '25px',
                        height: '25px',
                        borderRadius: '50%',
                        backgroundColor: cartCount > 0 ? '#f60' : '#2a3644',
                        color: cartCount > 0 ? 'white' : '#848484',
                      }}
                    >
                      <span>{cartCount}</span>
                    </div>
                  </button>
                </div>

                {!isEmpty(selectedAddress) ? (
                  <div className=" text-white" style={{ marginTop: '30px' }}>
                    <div className="flex items-center mb-3">
                      <img
                        src={locationIcon}
                        alt="locationIcon"
                        style={{
                          width: '11.6px',
                          height: '14.9px',
                        }}
                      />
                      <span className="text-xl font-semibold ml-3">Deliver to</span>
                    </div>
                    <div className="">
                      <div className="text-xs">
                        {Object.keys(selectedAddress)
                          .filter((e) => e !== 'id' && e !== 'default')
                          .map((key, index) => (
                            <div key={index} className="flex">
                              <span className="w-20 mb-2.5" style={{ color: '#979797' }}>
                                {snakeToTitle(key)}
                              </span>
                              <div className="w-3/4">
                                <span className="text-white">{selectedAddress[key]}</span>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            {/* Related Products & Reviews Tabs */}
            <div className="mb-8 mt-6 xl:mt-4">
              <div className="flex space-x-8 border-b border-gray-700">
                {/* Related Products Button */}
                <button
                  onClick={() => handleTabChange('related_product')}
                  disabled={isTransitioning}
                  className="pb-2 xl:text-[22px] text-base font-semibold"
                  style={{
                    color: selectedTab === 'related_product' ? '#ff6600' : '#cecece',
                    borderBottom: selectedTab === 'related_product' ? '2px solid #ff6600' : '',
                    transition: 'all 0.4s ease',
                  }}
                >
                  RELATED PRODUCTS
                </button>

                {/* Reviews Button */}
                <button
                  onClick={() => handleTabChange('reviews')}
                  disabled={isTransitioning}
                  className="pb-2 xl:text-[22px] text-base  font-semibold"
                  style={{
                    color: selectedTab === 'reviews' ? '#ff6600' : '#cecece',
                    borderBottom: selectedTab === 'reviews' ? '2px solid #ff6600' : '',
                    transition: 'all 0.4s ease',
                  }}
                >
                  REVIEWS
                </button>
              </div>
            </div>

            {/* Tab Content with Transition */}
            <div
              style={{
                opacity: show ? 1 : 0,
                transition: 'opacity 0.4s ease',
              }}
            >
              {selectedTab === 'reviews' && (
                <ReviewsListing type={'products'} id={product_id} title={product?.title} />
              )}
              {selectedTab === 'related_product' && (
                <RelatedProduct
                  data={relatedProducts?.data || []}
                  loading={relatedProductsLoading}
                />
              )}
            </div>
          </div>
        )}
        {shareModal && (
          <ShareModal
            onClose={() => setShareModal(false)}
            link={create_share_url()}
            detailObj={{}}
          />
        )}
        {openDescriptionModal && (
          <DescriptionModal
            onClose={() => setOpenDescriptionModal(false)}
            text={product?.description || ''}
          />
        )}
      </div>
    </div>
  )
}

export default ProductDetail
